<form [formGroup]="formGroup" class="left">
  <mat-form-field>
    <wz-select2
      enumItemsKey="TITULAIRE_CARTE_GRISE_ENUM"
      placeholder="Titulaire de la carte grise ?"
      formControlName="titulaireCarteGrise"
    ></wz-select2>
  </mat-form-field>
  <mat-form-field>
    <wz-select2
      enumItemsKey="USAGE_ENUM"
      placeholder="Information sur l'utilisation de votre véhicule ?"
      formControlName="usage"
    ></wz-select2>
  </mat-form-field>
  <mat-form-field>
    <wz-select2
      enumItemsKey="GARAGE_ENUM"
      placeholder="Stationnement du véhicule ?"
      formControlName="garage"
    >
    </wz-select2>
  </mat-form-field>
  <div class="city-container" formGroupName="codeInseePerso">
    <mat-form-field class="zip">
      <wz-text-input
        placeholder="Code postal"
        formControlName="codePostal"
      ></wz-text-input>
    </mat-form-field>
    <mat-form-field class="city">
      <wz-select2
        [items]="cityList"
        [isLoading]="isFetchingCities"
        placeholder="Commune de stationnement la nuit"
        formControlName="codeInsee"
      ></wz-select2>
      <mat-hint *ngIf="isFetchingCities"
        >Récupération des villes correspondantes</mat-hint
      >
      <mat-hint *ngIf="!isFetchingCities && cityList && cityList.length === 0"
        >Aucune ville ne correspond à ce code postal</mat-hint
      >
    </mat-form-field>
  </div>
  <div class="city-container" formGroupName="codeInseePro">
    <mat-form-field class="zip">
      <wz-text-input
        placeholder="Code postal"
        formControlName="codePostal"
      ></wz-text-input>
    </mat-form-field>
    <mat-form-field class="city">
      <wz-select2
        [items]="cityProList"
        [isLoading]="isFetchingProCities"
        placeholder="Commune de votre lieu de travail"
        formControlName="codeInsee"
      ></wz-select2>
      <mat-hint *ngIf="isFetchingProCities"
        >Récupération des villes correspondantes</mat-hint
      >
      <mat-hint
        *ngIf="!isFetchingProCities && cityProList && cityProList.length === 0"
        >Aucune ville ne correspond à ce code postal</mat-hint
      >
    </mat-form-field>
  </div>
  <mat-form-field>
    <wz-select2
      enumItemsKey="FINANCEMENT_ENUM"
      placeholder="Financement du véhicule ?"
      formControlName="financement"
    >
    </wz-select2>
  </mat-form-field>
  <mat-form-field *ngIf="!forTunnelApp">
    <wz-select2
      enumItemsKey="NOMBRE_KILOMETRES_ANNUEL_ENUM"
      placeholder="Kilométrage effectué par an ?"
      formControlName="nombreKmAnnuel"
    ></wz-select2>
  </mat-form-field>
  <mat-form-field>
    <wz-select2
      enumItemsKey="VEHICULE_DEJA_ASSURE_ENUM"
      placeholder="Ce véhicule est-il actuellement assuré ?"
      formControlName="vehiculeDejaAssure"
    ></wz-select2>
  </mat-form-field>
</form>
